import React from 'react';

/**
 * 
 * @param {string} key 
 * @param {string} caption 
 * @param {content} caption 
 * @returns a `div` with a `label` with `content`. This is intended to add a `caption` above an form input
 */
export const genericFieldLabelContainer = (key, caption, content, className) => {
  return <div key={key} className={'field ' + className} >
    <label>{caption}</label>
    {content}
  </div>
}
